import dayjs from "dayjs";
import { BRAND } from "../../types";
import { stripHtml } from "@/utils/format";

/** 格式化日期：2026-05-01 → 5月1日 */
function fmtDate(date?: string): string {
  if (!date) return "";
  const d = dayjs(date);
  return d.isValid() ? d.format("M月D日") : date;
}

/** 从地址中提取城市名：四川省成都市双流区... → 成都市 */
function extractCity(address: string): string {
  const match = address.match(/[^省]+?市|[^省]+?(自治州|地区)|^[^区]+$/);
  return (match?.[0] || address).replace(/[县区].*$/, "").trim();
}

interface TripSummaryProps {
  /** 行程摘要文字 */
  spec: string;
  /** 取车地点 */
  pickupLocation?: string;
  /** 还车地点 */
  returnLocation?: string;
  /** 取车日期 */
  pickupDate?: string;
  /** 还车日期 */
  returnDate?: string;
  /** 租赁天数 */
  rentDays?: number;
}

export function TripSummary({ spec, pickupLocation, returnLocation, pickupDate, returnDate, rentDays }: TripSummaryProps) {
  // 清洗后端 address 字段里夹带的 HTML 标签（部分酒店会出现）
  const safePickup = stripHtml(pickupLocation);
  const safeReturn = stripHtml(returnLocation);
  const locText = safePickup && safeReturn
    ? `${extractCity(safePickup)} → ${extractCity(safeReturn)}`
    : (spec || "行程信息");
  const dateText = pickupDate && returnDate
    ? `${fmtDate(pickupDate)} ~ ${fmtDate(returnDate)}`
    : (pickupDate ? fmtDate(pickupDate) : "待确认");

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      <div className="flex items-center gap-2 mb-1">
        <i
          className="ri-map-pin-2-line"
          style={{ color: BRAND, fontSize: 15 }}
        />
        <div className="text-sm font-bold text-gray-900">
          {locText}
        </div>
      </div>
      <div className="text-xs text-gray-400">{dateText}</div>
      {rentDays != null && rentDays > 0 && (
        <div className="text-xs text-gray-400 mt-0.5">
          共 {rentDays} 天
        </div>
      )}
    </div>
  );
}
